import React, { Suspense } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

import { IconProps } from './Icon.types';

const useStyles = makeStyles({
  root: (props: any) => ({
    width: props.width,
    height: props.height,
    '& > svg': {
      width: props.width,
      height: props.height,
    },
  }),
});

const Icon:React.FC<IconProps> = ({
  icon,
  alt,
  color,
  width,
  height,
  className,
 }) => {

  if (width != '1em' && height == '1em') {
    height = 'auto'
  }

  if (height != '1em' && width == '1em') {
    width = 'auto'
  }

  const classes = useStyles({ width, height });

  if (!icon) return null;

  let Icon = null;

  if (typeof icon === 'string') {
      return <img alt={alt} className={clsx(color, classes.root, className)} src={icon} />
  } else {
      Icon = icon;
  }

  return (
    <Suspense fallback={<></>}>
      <Icon className={clsx(classes.root, color, className)} color={color} />
    </Suspense>
  );
};

Icon.defaultProps = {
  color: 'primary',
  className: '',
  width: '1em',
  height: '1em',
};

export default Icon;
export { IconProps };
